import React from "react";
import { Compass, Strategy, Shield, ChartBar } from "@phosphor-icons/react";

const PILLARS = [
  {
    icon: Compass,
    title: "Participation, Not Prediction",
    body:
      "Stop guessing tops and bottoms. Learn to read where institutions accept value, where they reject it, and when real aggression enters the tape.",
  },
  {
    icon: ChartBar,
    title: "Two Lenses, One Edge",
    body:
      "Market Profile gives you structure. Order Flow gives you confirmation. Combined, they form the framework professional desks have used for decades.",
  },
  {
    icon: Strategy,
    title: "Built for the Indian Market",
    body:
      "Nifty, Bank Nifty, Midcap and MCX commodities. Templates for GoCharting, daily levels, EOD level-drawing sessions. Designed for our market hours.",
  },
  {
    icon: Shield,
    title: "Patience Before P&L",
    body:
      "For the first 2 months you only observe. No live trading. We build pattern recognition first, conviction second, and execution last.",
  },
];

export default function Why() {
  return (
    <section
      data-testid="why-section"
      id="why"
      className="py-20 lg:py-28 border-t border-[#D4D0C5]"
    >
      <div className="max-w-[1320px] mx-auto px-5 lg:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
          <div className="lg:col-span-4">
            <div className="font-mono-acc text-[10px] tracking-[0.3em] uppercase text-[#D9381E] mb-4">
              01 / WHY THIS COURSE
            </div>
            <h2 className="font-display font-black text-4xl lg:text-5xl leading-[0.95] tracking-tighter">
              Markets move
              <br />
              by{" "}
              <span className="italic font-light tracking-tight">
                participation
              </span>
              ,<br />
              not by
              <br />
              <span className="text-[#D9381E]">prediction.</span>
            </h2>
            <p className="font-body text-[#4A4A4A] mt-6 max-w-md">
              This is the single belief that separates a retail trader from a
              market participant. Everything in this program is built around
              it.
            </p>
          </div>

          <div className="lg:col-span-8 grid grid-cols-1 md:grid-cols-2 gap-px bg-[#D4D0C5] border border-[#D4D0C5]">
            {PILLARS.map((p, idx) => {
              const Icon = p.icon;
              return (
                <div
                  key={idx}
                  data-testid={`pillar-${idx}`}
                  className="bg-[#F4F3ED] p-7 lg:p-9 group hover:bg-[#EAE8DF] transition-colors"
                >
                  <div className="flex items-center justify-between mb-5">
                    <Icon size={26} weight="duotone" />
                    <span className="font-mono-acc text-[10px] tracking-[0.25em] text-[#4A4A4A]">
                      0{idx + 1}
                    </span>
                  </div>
                  <h3 className="font-display font-black text-xl tracking-tight mb-2">
                    {p.title}
                  </h3>
                  <p className="font-body text-sm text-[#4A4A4A] leading-relaxed">
                    {p.body}
                  </p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
